module.exports = __webpack_public_path__ + "img/tpay-etisalat.95a0aa15.jpg";